module.exports = {"150923101":"七台镇","150923102":"十八顷镇","150923103":"大黑沙土镇","150923104":"西井子镇","150923105":"屯垦队镇","150923106":"小海子镇","150923200":"大库伦乡","150923201":"卯都乡","150923202":"玻璃忽镜乡","150923203":"三大顷乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150923.json
// module id = 469
// module chunks = 0